import React, { useState } from 'react'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import Save from "../../Assets/images/save.svg";
import Saved from "../../Assets/images/saved.svg";
import Progress from '../Home/Progress';
import { Link } from 'react-router-dom';
import Constant from '../../Constant';
import { toast } from 'react-toastify';
import postService from '../../Services/post-service';
import Loading from '../SelectValue/Loading';
import Skeleton from '@mui/material/Skeleton';

function LandCom({ bool, onClick, link, name, img, locationName, navState, per, percentage, totalAmount, raisedAmount, id, saveStatus, loading: componentLoading, onRemove }) {
  const [loading, setLoading] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(saveStatus || false);
  const [interacted, setInteracted] = useState(false);

  React.useEffect(() => {
    if (!interacted) {
      setIsBookmarked(saveStatus || false);
    }
  }, [saveStatus, interacted]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setInteracted(true);
    if (isBookmarked) {
      postService.removePropertyBuyLater(id).then(
        (response) => {
          setLoading(false);
          if (response.data.statusCode === 200) {
            setIsBookmarked(false);
            toast.success(response.data.description, { autoClose: 1000 });
            if (onRemove) {
              onRemove(id);
            }
          } else {
            toast.error(response.data.description, { autoClose: 1000 });
          }
        },
        (error) => {
          setLoading(false);
          toast.error(error?.response?.data?.description, { autoClose: 1000 });
        }
      );
    } else {
      postService.saveProduct(id, "INVESTMENT").then(
        (response) => {
          setLoading(false);
          if (response.data.statusCode === 200) {
            setIsBookmarked(true);
            toast.success(response.data.description, { autoClose: 1000 });
          } else {
            toast.error(response.data.description, { autoClose: 1000 });
          }
        },
        (error) => {
          setLoading(false);
          toast.error(error?.response?.data?.description, { autoClose: 1000 });
        }
      );
    }
  };

  if (componentLoading) {
    return (
      <div className=' p-2 grid grid-cols-1 sm:grid-cols-5 gap-3 border border-gray-200 shadow rounded-lg '>
        <div className=' sm:col-span-2'>
          <Skeleton variant="rectangular" width="100%" height={128} sx={{ pt: 3 }} />
        </div>
        <div className=' sm:col-span-3 w-full'>
          <div className=' flex justify-between mt-3 mb-1'>
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="circular" width={24} height={24} />
          </div>
          <div className=' mb-3'>
            <Skeleton variant="text" width="40%" height={20} />
          </div>
          <div>
            <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" width="100%" height={10} sx={{ borderRadius: 1, mb: 2 }} />
            <div className=' mb-4 flex justify-between'>
              <Skeleton variant="text" width="20%" height={14} />
              <Skeleton variant="text" width="20%" height={14} />
            </div>
            <div className=' mb-2 flex justify-between'>
              <Skeleton variant="text" width="40%" height={20} />
              <Skeleton variant="text" width="40%" height={20} />
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div>
      <Loading
        open={loading}
      />

      <div className=' p-2  grid grid-cols-1 sm:grid-cols-5 gap-3  border border-gray-200 shadow rounded-lg '>
        <div className=' sm:col-span-2'>
          {link ? (
            <Link to={link} state={navState}>
              <img src={img} height={50} width={50} className=' h-32 pt-3 w-full' alt='image' />
            </Link>
          ) : (
            <img src={img} height={50} width={50} className=' h-32 pt-3 w-full' alt='image' />
          )}
        </div>
        <div className=' sm:col-span-3 w-full'>

          <div className=' flex justify-between mt-3 mb-1'>
            <p className=' text-back-color2 font-[500] capitalize text-[16px]'>{name}</p>
            <div onClick={handleSubmit} className=" cursor-pointer flex items-center gap-1">
              <img src={isBookmarked ? Saved : Save} className="w-4 h-4" alt="save" />
              <span className=" text-back-color2 text-[13px] font-semibold">
                {isBookmarked ? "Saved" : "Save"}
              </span>
            </div>


          </div>
          {link ? (
            <Link to={link} state={navState}>
              <div className=' mb-3'>
                <PlaceOutlinedIcon onClick={onClick} fontSize="small" className='text-primary-color6' /> <p className=' text-[#44474E] text-[14px] capitalize inline-block pl-1'>{locationName}</p>
              </div>
              <div>
                <p className=' text-[14px] pb-2'>{per}% sold</p>
                <Progress value={percentage} />
                <div className=' mb-4 flex justify-between'>
                  <p className='text-primary-color6 text-[14px]'>Target</p>
                  <p className='text-primary-color6 text-[14px]'>Raised</p>
                </div>
                <div className=' mb-2 flex justify-between'>
                  <p className=' text-[14px] text-start'>NGN {Constant.FormatNumber(totalAmount)}</p>
                  <p className='text-[14px] text-end text-primary-color'>NGN {Constant.FormatNumber(raisedAmount)}</p>
                </div>
              </div>
            </Link>
          ) : (
            <>
              <div className=' mb-3'>
                <PlaceOutlinedIcon onClick={onClick} fontSize="small" className='text-primary-color6' /> <p className=' text-[#44474E] text-[14px] capitalize inline-block pl-1'>{locationName}</p>
              </div>
              <div>
                <p className=' text-[14px] pb-2'>{per}% sold</p>
                <Progress value={percentage} />
                <div className=' mb-4 flex justify-between'>
                  <p className='text-primary-color6 text-[14px]'>Target</p>
                  <p className='text-primary-color6 text-[14px]'>Raised</p>
                </div>
                <div className=' mb-2 flex justify-between'>
                  <p className=' text-[14px] text-start'>NGN {Constant.FormatNumber(totalAmount)}</p>
                  <p className='text-[14px] text-end text-primary-color'>NGN {Constant.FormatNumber(raisedAmount)}</p>
                </div>
              </div>
            </>
          )}

        </div>
      </div>
    </div>
  )
}

export default LandCom